<template>
  <div class="header" id="headerBox">
    <router-link to="home">
      <div class="header-img"></div>
    </router-link>
    <div class="header-title">中消在线</div>
    <div class="header-subtitle">消防一站式服务平台</div>
    <div class="header-info" v-show="isLogin" @click="gotoUser">
      <img v-show="userinfo.ent_logo.length > 0" :src="resourceUrl + userinfo.ent_logo" />
      <img v-show="userinfo.ent_logo.length <= 0" src="../assets/icon-head.jpg">
    </div>
    <!--    <router-link to="/login?back=1">-->
    <button @click="loginClick" class="header-login" v-show="!isLogin">登 录</button>
    <!--    </router-link>-->
    <div class="header-menu" @click="value1 = true"></div>
    <Drawer title="" :closable="false" v-model="value1" width="40">
      <br />
      <div class="header-item" v-for="(value,index) in headerItems" :key="index" @click="gotoLink(value.link,index)">
        <img :src="value.image" />
        <span>{{value.title}}</span>
      </div>
      <div class="logout" v-show="isLogin" @click="logoutClick">退出登录</div>
    </Drawer>

    <AlertView :show="showAlert" title="" subTitle="确认退出登录？" cancelTitle="取消" sureTitle="确定"
      @alertViewClick="alertViewClick"></AlertView>
  </div>
</template>

<script>
import AlertView from '../components/alert-view'
export default {
  data () {
    return {
      showAlert: false,
      value1: false,
      resourceUrl: this.utils.ResourceUrl,
      headerItems: [
        { 'id': '1', 'title': '首页', 'image': require('../assets/home-top1.png'), 'link': '/home' },
        { 'id': '2', 'title': '在线培训', 'image': require('../assets/home-top2.png'), 'link': '/online-training' },
        { 'id': '3', 'title': '在线审图', 'image': require('../assets/home-top3.png'), 'link': '/online-mapping' },
        { 'id': '4', 'title': '应急保障', 'image': require('../assets/home-top4.png'), 'link': '/emergency-support' },
        { 'id': '5', 'title': '专家咨询', 'image': require('../assets/home-top5.png'), 'link': '/ask-question' },
        { 'id': '6', 'title': '安全管家', 'image': require('../assets/home-top6.png'), 'link': '/safe-manager' },
        { 'id': '7', 'title': '企业名录', 'image': require('../assets/home-top7.png'), 'link': '/enterprise-list' },
        { 'id': '8', 'title': '消防百科', 'image': require('../assets/home-top8.png'), 'link': '/news-list' },
        { 'id': '9', 'title': '在线商城', 'image': require('../assets/home-top9.png'), 'link': '/homePage/goodslist' }
      ],
      isLogin: 0,
      userinfo: {
        'ent_logo': ''
      }
    }
  },
  watch: {
    $router () {
    }
  },
  methods: {
    gotoUser () {
      localStorage.setItem('tab', 2)
      this.$router.replace({
        path: '/homePage/personHomePage?isTab=1'
      }).catch(err => { return err })
    },
    loginClick: function () {
      this.$router.push({ path: 'login', query: { back: 1 } })
    },
    gotoLink: function (link, index) {
      if (link.indexOf('http') >= 0) {
        window.location.href = link
      } else {
        // console.log('=======' + link)
        this.$router.push({ path: link })
      }
    },
    logoutClick: function () {
      this.value1 = false
      this.showAlert = true
    },
    alertViewClick: function (index) {
      this.showAlert = false
      var _this = this
      if (index === 1) {
        this.utils.GET(this.accountUrl + '/account/logout', function (response) {
          localStorage.setItem('isLogin', 0)
          localStorage.setItem('userinfo', '')
          localStorage.removeItem('shop')
          localStorage.removeItem('planInfo')
          _this.isLogin = 0
          _this.userinfo = {
            ent_logo: ''
          }
          _this.$emit('logout')
          console.log('退出登录------------------')
        })
      }
    },
    loadLoginState: function () {
      var _this = this
      this.utils.isUserLogin(function (login) {
        if (login === 1) {
          _this.isLogin = localStorage.getItem('isLogin')
          _this.userinfo = JSON.parse(localStorage.getItem('userinfo'))
          if (_this.userinfo.ent_logo === undefined) {
            _this.userinfo.ent_logo = ''
          }
          console.log('头像==========' + _this.userinfo.ent_logo)
          console.log(_this.userinfo)
        }
      })
    },
    getInfo: function () {
      // APP 嵌入H5 处理用户信息
      localStorage.setItem('isLogin', 1)
      var _this = this
      this.utils.GET(this.companyUrl + '/ent/json',
        function (data) {
          localStorage.setItem('userinfo', JSON.stringify(res.data))
          console.log(localStorage.getItem('userinfo'))
        })
    }
  },
  components: {
    AlertView
  },
  mounted () {
    // 登录状态
    this.loadLoginState()
    // App 内嵌H5界面 隐藏头部 、、 保存isApp信息 方便取用
    console.log('isApp===========' + parseInt(localStorage.getItem('isApp')))
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      console.log('是APP================')
      localStorage.setItem('isApp', this.$route.query.isApp)
      this.getInfo()
      setTimeout(function () {
        document.getElementById('headerBox').style.display = 'none'
      }, 500)
    }
  }
}
</script>

<style scoped>
.header {
  height: 55px;
  background-color: #103154;
  z-index: 200;
}
.header .header-img {
  position: absolute;
  top: 10px;
  left: 15px;
  height: 34px;
  width: 40px;
  background-image: url(../assets/home-logo.png);
  background-size: cover;
  background-position: center center;
}
.header .header-title {
  position: absolute;
  top: 10px;
  left: 70px;
  height: 20px;
  line-height: 20px;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
}
.header .header-subtitle {
  position: absolute;
  top: 30px;
  left: 70px;
  height: 15px;
  line-height: 15px;
  color: #769fb8;
  font-size: 12px;
}
.header .header-menu {
  position: absolute;
  top: 20px;
  right: 15px;
  width: 15px;
  height: 15px;
  color: #808080;
  font-size: 12px;
  background-image: url(../assets/home-top-more-blue.png);
  background-size: cover;
  background-position: center center;
}
.header .header-login {
  position: absolute;
  top: 15px;
  right: 50px;
  width: 60px;
  height: 25px;
  line-height: 25px;
  color: #ffffff;
  font-size: 13px;
  background-color: #c41335;
  border-radius: 13px;
  text-align: center;
}
.header .header-info {
  position: absolute;
  top: 7px;
  right: 50px;
  width: 40px;
  height: 40px;
  background-color: #eeeeee;
  border-radius: 20px;
}
/*.header .header-info .title{*/
/*  position: absolute;*/
/*  top: 5px;*/
/*  left: 10px;*/
/*  bottom: 5px;*/
/*  right: 40px;*/
/*  width: 65px;*/
/*  height: 30px;*/
/*  line-height: 30px;*/
/*  margin: 0 auto;*/
/*  color: #808080;*/
/*  font-size: 10px;*/
/*  text-align: center;*/
/*  word-wrap:break-word;*/
/*  overflow: hidden;*/
/*  text-overflow: ellipsis;*/
/*}*/
.header .header-info img {
  position: absolute;
  right: 0px;
  width: 40px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 2px;
  border: solid #cccccc 1px;
}
.header-item {
  height: 40px;
  /*border: solid #26A2FF 1px;*/
}
.header-item img {
  position: relative;
  left: 0px;
  top: 5px;
  width: 20px;
  height: 20px;
  /*float: left;*/
}
.header-item span {
  margin-left: 7px;
  position: relative;
  top: 0px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #000000;
}
.logout {
  position: absolute;
  top: 420px;
  left: 15px;
  right: 15px;
  height: 36px;
  line-height: 36px;
  /*width: 100%;*/
  /*border:solid #EEEEEE 1px;*/
  /*box-sizing: border-box;*/
  background-color: #eeeeee;
  border-radius: 2px;
  text-align: center;
  color: #c41335;
  font-size: 13px;
  /*background-color: yellow;*/
}
</style>



// WEBPACK FOOTER //
// src/view/evaluator-header.vue